(() => {
  'use strict';
  const configElement = document.querySelector('[data-minty-recognition-config]');
  if (!configElement || window.mintyRecognitionInitialized) return;
  let config;
  try { config = JSON.parse(configElement.textContent); } catch { return; }
  window.mintyRecognitionInitialized = true;
  const labels = config.labels || {};
  const types = {
    'Printed by Minty Tees': ['printed', 'shirt'],
    'Repeat Minty Client': ['repeat', 'award'],
    'Merch Available Here': ['merch', 'bag'],
    'Creative Work by Minty Tees': ['creative', 'star']
  };
  const paths = {
    shirt: 'M8 3 3 6l2 5 3-1v11h8V10l3 1 2-5-5-3a4 4 0 0 1-8 0Z',
    award: 'M9 15 7 22l5-3 5 3-2-7M12 2a7 7 0 1 0 0 14 7 7 0 0 0 0-14Z',
    bag: 'M5 7h14l1 14H4L5 7Zm3 0V5a4 4 0 0 1 8 0v2',
    star: 'm12 2 3 6 7 1-5 5 1 7-6-3-6 3 1-7-5-5 7-1 3-6Z'
  };
  const text = (key, brand = '') => String(labels[key] || '').split('__BRAND__').join(brand);
  const el = (tag, className, content) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (content) node.textContent = content;
    return node;
  };
  const icon = (kind) => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    for (const [key, value] of Object.entries({viewBox: '0 0 24 24', width: '22', height: '22', fill: 'none', stroke: 'currentColor', 'stroke-width': '1.6', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'aria-hidden': 'true', focusable: 'false'})) svg.setAttribute(key, value);
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', paths[kind]);
    svg.append(path);
    return svg;
  };
  const hasMerch = (brand) => (Array.isArray(brand.products) && brand.products.length > 0) || (Array.isArray(brand.collections) && brand.collections.some(c => Number(c.product_count) > 0));
  const badgeFor = (brand) => {
    if (!Object.hasOwn(types, brand.minty_badge_type)) return null;
    if (brand.minty_badge_type === 'Merch Available Here' && !hasMerch(brand)) return null;
    return types[brand.minty_badge_type];
  };
  const badge = (brand, href) => {
    const type = badgeFor(brand);
    if (!type) return null;
    const node = el(href ? 'a' : 'span', 'minty-recognition-badge minty-recognition-badge--' + type[0]);
    if (href) node.href = href;
    node.append(icon(type[1]), el('span', '', text(type[0])));
    return node;
  };
  const inquiryUrl = (brand, service) => {
    const url = new URL('/pages/contact', location.origin);
    url.searchParams.set('source', 'brand-directory');
    url.searchParams.set('brand', brand.handle);
    url.searchParams.set('brand_name', brand.name || brand.handle);
    url.searchParams.set('service', service);
    return url.pathname + url.search + '#ContactForm';
  };
  const inquiry = (brand, service) => {
    const box = el('aside', 'minty-service-box');
    const prefix = service === 'merchandise' ? 'merch' : service === 'creative' ? 'creative' : 'printing';
    box.append(el('h3', '', text(prefix + 'CtaHeading')), el('p', '', text(prefix + 'CtaText')));
    const link = el('a', 'minty-recognition-action', text(prefix + 'CtaButton'));
    link.href = inquiryUrl(brand, service);
    box.append(link);
    return box;
  };
  const contact = document.getElementById('ContactForm');
  if (contact) {
    const params = new URLSearchParams(location.search);
    const handle = params.get('brand') || '';
    const service = params.get('service') || '';
    if (params.get('source') === 'brand-directory' && /^[a-z0-9][a-z0-9-]{0,180}$/.test(handle) && ['printing', 'creative', 'merchandise'].includes(service)) {
      const name = (params.get('brand_name') || handle).slice(0, 200);
      const prefix = service === 'merchandise' ? 'merch' : service === 'creative' ? 'creative' : 'printing';
      const context = el('p', 'minty-inquiry-context', text('inquiryContext', name) + ' ' + text(prefix + 'CtaHeading'));
      contact.prepend(context);
      for (const [key, value] of Object.entries({'Reference Brand': name, 'Reference URL': location.origin + '/pages/brand/' + handle, 'Requested Service': service, 'Source': 'Minty Brand Directory'})) {
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = 'contact[' + key + ']'; input.value = value;
        contact.append(input);
      }
    }
    return;
  }
  const page = document.querySelector('.brand-page');
  const grid = document.getElementById('brands-grid');
  if (!page && !grid) return;
  const ensureWork = (brand) => {
    let section = document.getElementById('minty-brand-work');
    if (section) return section;
    section = Array.from(page.querySelectorAll('section')).find(s => s.querySelector('img[alt^="Minty Tees work for"]') || (s.querySelector('h2')?.textContent.trim() === 'Made for ' + brand.name + ' by Minty Tees'));
    if (!section) {
      section = el('section', 'minty-brand-work');
      section.append(el('h2', '', text('workHeading', brand.name)));
      if (brand.minty_badge_text) section.append(el('p', 'minty-recognition-copy', brand.minty_badge_text));
      const anchor = document.getElementById('brand-appearances');
      if (anchor) anchor.before(section); else page.append(section);
    } else {
      const heading = section.querySelector('h2');
      if (heading) heading.textContent = text('workHeading', brand.name);
    }
    section.id = 'minty-brand-work';
    section.classList.add('minty-brand-work');
    const projectLink = Array.from(page.querySelectorAll('a[href]')).find(a => /\/blogs\//.test(a.getAttribute('href')) && /printed|shirt|work/i.test(a.textContent));
    if (projectLink && !section.contains(projectLink)) {
      const link = el('a', 'minty-recognition-action minty-recognition-action--secondary', text('projectLink'));
      const target = new URL(projectLink.href, location.origin);
      if (target.origin === location.origin) { link.href = target.pathname; section.append(link); }
    }
    section.append(inquiry(brand, brand.minty_badge_type === 'Creative Work by Minty Tees' ? 'creative' : 'printing'));
    return section;
  };
  const enhancePage = (brand) => {
    const title = page.querySelector('h1');
    if (!title) return;
    const selected = badgeFor(brand);
    const merchandise = hasMerch(brand);
    if (selected && selected[0] !== 'merch') ensureWork(brand);
    if ((selected || merchandise) && !document.getElementById('minty-recognition-head')) {
      const panel = el('aside', 'minty-recognition-head');
      panel.id = 'minty-recognition-head';
      panel.setAttribute('aria-label', text('relationshipLabel'));
      const merchandiseTarget = Array.isArray(brand.collections) && brand.collections.some(c => Number(c.product_count) > 0) ? '#brand-collections' : '#brand-products';
      const award = badge(brand, selected && selected[0] === 'merch' ? merchandiseTarget : '#minty-brand-work');
      if (award) panel.append(award);
      if (selected && brand.minty_badge_text) panel.append(el('p', 'minty-recognition-copy', brand.minty_badge_text));
      if (merchandise) {
        const link = el('a', 'minty-recognition-action minty-recognition-action--secondary', text('shopBrand', brand.name));
        link.href = merchandiseTarget;
        panel.append(link);
      }
      const slot = page.querySelector('#minty-brand-recognition-slot');
      if (slot) slot.append(panel);
      else { const brandHero = page.querySelector('.mt-brand-profile-head'); (brandHero || title.parentElement).after(panel); }
    }
    if (!merchandise) return;
    const collections = document.getElementById('brand-collections');
    const products = document.getElementById('brand-products');
    const target = collections?.querySelector('.mt-design-link') ? collections : products?.querySelector('.mt-prod-card') ? products : null;
    if (!target) return;
    if (brand.merch_supports_brand === true && !target.querySelector('.minty-merch-support')) {
      target.prepend(el('p', 'minty-merch-support', text('supportText', brand.name)));
    }
    if (!document.getElementById('minty-merch-inquiry')) {
      const box = inquiry(brand, 'merchandise');
      box.id = 'minty-merch-inquiry';
      const after = products?.querySelector('.mt-prod-card') ? products : target;
      after.after(box);
    }
  };
  const enhanceCards = (brands) => {
    for (const card of grid.querySelectorAll('.mt-brand-card')) {
      if (card.querySelector('.minty-card-recognition')) continue;
      let handle;
      try { handle = decodeURIComponent(new URL(card.href, location.origin).pathname.split('/').filter(Boolean).pop()); } catch { continue; }
      const brand = brands.get(handle);
      if (!brand || !badgeFor(brand)) continue;
      const name = card.querySelector('.mt-brand-name');
      if (!name) continue;
      const panel = el('div', 'minty-card-recognition');
      panel.append(badge(brand));
      if (brand.minty_badge_text) panel.append(el('p', 'minty-recognition-copy', brand.minty_badge_text));
      name.after(panel);
    }
  };
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 12000);
  fetch(config.indexUrl, {signal: controller.signal, credentials: 'omit'})
    .then(response => { if (!response.ok) throw new Error('Directory data unavailable'); return response.json(); })
    .then(index => {
      const brands = new Map(Object.values(index).filter(b => b && b.handle && b.visible !== false).map(b => [b.handle, b]));
      const handle = location.pathname.split('/').filter(Boolean).pop();
      const brand = brands.get(handle);
      const refresh = () => { if (page && brand) enhancePage(brand); if (grid) enhanceCards(brands); };
      if (page) window.addEventListener('minty:brand-content-ready', refresh);
      if (grid) {
        let scheduled = false;
        const observer = new MutationObserver(() => {
          if (scheduled) return;
          scheduled = true;
          requestAnimationFrame(() => { scheduled = false; refresh(); });
        });
        observer.observe(grid, {childList: true, subtree: true});
      }
      refresh();
    })
    .catch(() => { window.mintyRecognitionDataUnavailable = true; })
    .finally(() => clearTimeout(timeout));
})();
